import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaterialTooltip from '@material-ui/core/Tooltip';

class Tooltip extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    placement: PropTypes.string,
    tooltip: PropTypes.node,
  };

  static defaultProps = {
    placement: '',
    tooltip: '',
  };

  render() {
    const {
      children,
      placement,
      tooltip,
      ...rest
    } = this.props;

    return (
      <MaterialTooltip
        placement={placement || 'bottom'}
        title={tooltip}
        {...rest}
      >
        {children}
      </MaterialTooltip>
    );
  }
}

export default Tooltip;
